<template lang="pug">
  .b2b-page-usuario-detail
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('user_detail.info_user') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("user_detail.delete_user_tooltip")', placement='bottom')
                ods-button(
                  v-if='canAdminUserAdvanced',
                  type='primary',
                  icon='ods-icon-delete',
                  size='small',
                  circle,
                  @click.native='handleDeleteUser')
                  | {{ $t('user_detail.delete_user') }}
              ods-tooltip(:content='$t("user_detail.reset_pass_user")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-sync',
                  size='small',
                  circle,
                  @click.native='handleResetPassword')
                  | {{ $t('user_detail.reset_pass_user') }}
              ods-tooltip(:content='$t("user_detail.duplicate_user_tooltip")', placement='bottom')
                ods-button(
                  v-if='canAdminIndra || canAdminUserAdvanced',
                  type='primary',
                  icon='ods-icon-copy',
                  size='small',
                  circle,
                  @click.native='handleDuplicateUser')
                  | {{ $t('user_detail.duplicate_user') }}

      ods-form(
        ref='userDetailEditForm',
        :model='userDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:md='10')
            ods-form-item(
              :label='$t("user_detail.user_detail_edit_form.name")',
              prop='name')
              ods-input(
                v-model="userDetailEditForm.name",
                :disabled='true')
            ods-form-item(
              :label='$t("user_detail.user_detail_edit_form.first_surname")',
              prop='firstSurname')
              ods-input(
                v-model="userDetailEditForm.firstSurname",
                :disabled='true')
            ods-form-item(
              :label='$t("user_detail.user_detail_edit_form.second_surname")',
              prop='secondSurname')
              ods-input(
                v-model="userDetailEditForm.secondSurname",
                :disabled='true')
          ods-col(:md='4')
          ods-col(:md='10')
            ods-form-item(
              :label='$t("user_detail.user_detail_edit_form.department")',
              prop='department')
              ods-input(
                v-model="userDetailEditForm.department",
                :disabled='true')
            ods-form-item(
              :label='$t("user_detail.user_detail_edit_form.enable")',
              prop='enable')
              ods-switch(
                v-model="userDetailEditForm.enable",
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                @change='handleSetStatus()')
    ods-module.collapse
      ods-accordion(@change="loadUserMedia")
        ods-accordion-item(name='1')
          template(slot='title')
            span {{ $t('user_detail.user_media') }}
            span.info(v-show='!userMedia.length && userMediaMessage') {{ $t('user_detail.no_user_media') }}
          ods-tooltip(:content='$t("user_detail.add_user_media_tooltip")', placement='bottom')
            ods-button.button-collapse(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogAddUserMedia = true')
              | {{ $t('user_detail.add_user_media') }}

          //- Tabla de Datos de Contacto
          ods-table(
            :data='userMedia',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterUserMedia',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='mediaTypeName',
              :label='$t("user_detail.user_media_table.media_type_name")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='value',
              :label='$t("user_detail.user_media_table.value")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  type='neutral',
                  @click='removeUserMedia')
                  ods-icon(name='close', size='16')
      ods-accordion(@change="loadUserEntity")
        ods-accordion-item(
          v-if='canAdminUserAdvanced',
          name='2')
          template(slot='title')
            span {{ $t('user_detail.user_entity') }}
            span.info(v-show='!userEntities.length && userEntityMessage') {{ $t('user_detail.no_user_entity') }}
          ods-tooltip(:content='$t("user_detail.add_user_entity_tooltip")', placement='bottom')
            ods-button.button-collapse(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogAddUserEntity = true')
              | {{ $t('user_detail.add_user_entity') }}
          //- Tabla de Entidades de Usuario
          ods-table(
            :data='userEntities',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterUserEntity',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='projectName',
              :label='$t("user_detail.user_entity_table.project_name")',
              :show-overflow-tooltip='true',
              v-if='(showProject)',
              sortable='')
            ods-table-column(
              prop='partyTaxIdentificationNumber',
              :label='$t("user_detail.user_entity_table.party_tax_identification_number")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='centreCode',
              :label='$t("user_detail.user_entity_table.centre_code")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  type='neutral',
                  @click='removeUserEntity')
                  ods-icon(name='close', size='16')
      ods-accordion(@change="loadUserAuthorities")
        ods-accordion-item.profiles(
          v-if='canAdminUserAdvanced',
          name='3')
          template(slot='title')
            span {{ $t('user_detail.roles_authorities') }}
            span.info(v-show='!optionsUserEntitiesRolesAuthorities.length && userAuthoritiesMessage') {{ $t('user_detail.no_user_authorities') }}
            i(class='header-icon el-icon-information')
          ods-row
            ods-col(:span='24', style='text-align: right')
              ods-tooltip(:content='$t("user_detail.new_role")', placement='bottom')
                ods-button(
                  v-if='canAdminProfile',
                  type='primary',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='isShowDialogAddRole=true')
                  | {{ $t('user_detail.add_user_entity') }}
          //- Tabla de Perfiles/Permisos de Usuario
          ods-row(v-if='optionsUserEntitiesRolesAuthorities.length > 1')
            ods-col(:span='8')
              ods-form
                ods-form-item
                  ods-select(
                    v-model='projectSelectedRolesAuthorities',
                    filterable,
                    @change='changeProjectSelected()')
                    ods-option(
                      v-for='option in optionsUserEntitiesRolesAuthorities',
                      :key='option.projectId',
                      :label='option.projectName',
                      :value='option.projectId')
          ods-row
            ods-col(:span='7', style='text-align: center')
              span {{ $t('user_detail.roles') }}
            ods-col(:span='16', style='text-align: center')
              span {{ $t('user_detail.authorities') }}
          ods-row
            ods-col(:span='8')
              ods-scrollbar(wrapClass="wrap-styles")
                div(@click='handleChargeAuthoritiesByRole(role)',
                    v-for='role in userRolesAuthorities.roles',
                    :key='role.id')
                  ods-module.box-role(v-bind:class='{active: role == currentRole}')
                    ods-checkbox(
                      :label='role.roleName',
                      v-model='role.enabled')
                    ods-button(
                      icon='ods-icon-chevron-right',
                      style='float:right',
                      type='neutral')

            ods-col(:span='16')
              template(v-if='isNewRole')
                ods-scrollbar(wrapClass="wrap-styles")
                  ods-module.box-authority(
                    v-for='authority in userRolesAuthorities.authorities',
                    :key='authority.id')
                    ods-checkbox(
                      :label='authority.name',
                      :checked='authority.enabled')
              template(v-else)
                ods-scrollbar(wrapClass="wrap-styles")
                  ods-module.box-authority(
                    v-for='autho in authoritiesByRol',
                    :key='autho.id')
                    template(slot-scope='scope')
                      span {{ getDescriptionAuthority(autho.name) }}

          ods-row.b2b-page-usuario-detail__form-actions()
            ods-col(:span='24')
              ods-tooltip(:content='$t("user_detail.save_roles_authorities_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  @click='changeRoleAuthorities()')
                  | {{ $t('user_detail.save_roles_authorities') }}
              ods-tooltip(:content='$t("user_detail.cancel_roles_authorities_tooltip")', placement='bottom')
                ods-button(
                  ref='buttonCancel',
                  type='neutral',
                  @click='cancelChangeRoleAuthorities()')
                  | {{ $t('user_detail.cancel_roles_authorities') }}
    ods-row.form-actions(v-if='showSaveUser')
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            @click='saveUser()')
            | {{ $t('buttons.btnSaveChanges') }}

    //- Dialog Añadir Datos de Contacto
    ods-dialog(
      ref='dialogAddUserMedia'
      :title='$t("user_detail.dialog_add_user_media.title")',
      :visible.sync='isShowDialogAddUserMedia',
      @close='handleCloseDialogUserMedia',
      width='30%')

      ods-form(
        ref='formDialogAddUserMedia',
        :model='formDialogAddUserMedia',
        :rules='rulesFormDialogAddUserMedia',
        label-position='top')

        ods-form-item(
          :label='$t("user_detail.dialog_add_user_media.media_type_name")',
          prop='mediaTypeName')
          ods-select(
            v-model='formDialogAddUserMedia.mediaTypeName')
            ods-option(
              v-for='option in optionsUserMediaType',
              :key='option.id',
              :label='$t("mediaType." + option.media)',
              :value='option.media')
        ods-form-item(
          :label='$t("user_detail.dialog_add_user_media.value")',
          size='mini',
          prop='value')
          ods-input(
            v-model='formDialogAddUserMedia.value')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddUserMedia("formDialogAddUserMedia")')
          | {{ $t('user_detail.dialog_add_user_media.button_add') }}

    //- Dialogo cambiar el email del usuario
    ods-dialog(
      ref='dialogChangeUserEmail'
      :title='$t("user_detail.dialog_change_user_email.title")',
      :visible.sync='isShowDialogChangeUserEmail',
      @close='handleCloseDialogChangeUserEmail',
      width='30%')

      ods-form(
        ref='formDialogChangeUserEmail',
        :model='formDialogChangeUserEmail',
        :rules='rulesFormDialogChangeUserEmail',
        label-position='top')

        ods-form-item(
          :label='$t("user_detail.dialog_change_user_email.old_email")',
          size='mini',
          prop='oldEmail')
          ods-input(
            v-model='formDialogChangeUserEmail.oldEmail'
            :disabled='true')

        ods-form-item(
          :label='$t("user_detail.dialog_change_user_email.new_email")',
          size='mini',
          prop='newEmail')
          ods-input(
            v-model='formDialogChangeUserEmail.newEmail')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitChangeUserEmail("formDialogChangeUserEmail")')
          | {{ $t('user_detail.dialog_change_user_email.button_add') }}

    //- Dialogo crear perfiles
    ods-dialog(
      ref='dialogAddRole',
      :title='$t("form_new_role.new_role")',
      :visible.sync='isShowDialogAddRole',
      :append-to-body='true',
      @close='handleCloseDialog',
      width='40%')
      ods-form(
      ref='formDialogAddRole',
      :rules='rulesDialogAddRole',
      :model='formDialogAddRole',
      size='mini')
        ods-form-item(
          :label='$t("form_new_role.role")'
          prop='role')
          ods-input(v-model='formDialogAddRole.role')
        ods-form-item(
          :label='$t("form_new_role.description")'
          prop='description')
          ods-input(v-model='formDialogAddRole.description')
        ods-form-item(
          v-show='!(optionsUserEntitiesRolesAuthorities.length === 1)',
          :label='$t("form_new_role.service")',
          prop='servicio')
          ods-select(
          :no-match-text='$t("msg_generics.no_match")',
          v-model='formDialogAddRole.servicio',
          filterable,
          clearable,
          :placeholder='$t("form_new_role.dialog.service")')
            ods-option(
              v-for='optionProject in optionsUserEntitiesRolesAuthorities',
              :key='optionProject.projectId',
              :label='optionProject.projectName',
              :value='optionProject.projectId')
        ods-form-item(
          :label='$t("form_new_role.delete")',
          prop='borrable')
          ods-select(
          :no-match-text='$t("msg_generics.no_match")',
          v-model='formDialogAddRole.borrable',
          filterable,
          clearable,
          :placeholder='$t("form_new_role.dialog.delete")')
            ods-option(
              v-for='optionDelete in optionsDelete',
              :key='optionDelete.value',
              :label='optionDelete.label',
              :value='optionDelete.value')
        ods-form-item(
          :label='$t("form_new_role.permisos")',
          prop='permisos')
          ods-select(
          :no-match-text='$t("msg_generics.no_match")',
          v-model='formDialogAddRole.permisos',
          filterable,
          multiple,
          clearable,
          :placeholder='$t("form_new_role.dialog.permisos")')
            ods-option(
              v-for='optionsAuthoritie in optionsAuthorities',
              :key='optionsAuthoritie.id',
              :label='$t("authorities." + optionsAuthoritie.name) + " - " + $t("authorities_module." + optionsAuthoritie.module)',
              :value='optionsAuthoritie.id')
      span(slot='footer')
        ods-button(
          type='primary',
           @click.native='onSubmitAddRole("formDialogAddRole")')
          | {{ $t('form_new_role.submit') }}

    //- Dialog Añadir Entidades de Usuario
    ods-dialog(
      ref='dialogAddUserEntity',
      :title='$t("user_detail.dialog_add_user_entity.title")',
      :visible.sync='isShowDialogAddUserEntity',
      @close='handleCloseDialogUserEntity',
      width='30%')

      ods-form(
        ref='formDialogAddUserEntity',
        :model='formDialogAddUserEntity',
        :rules='rulesAddEntity'
        label-position='top')

        ods-form-item(
          v-show='!(activeUser.data.projects && activeUser.data.projects.length === 1)',
          :label='$t("user_detail.dialog_add_user_entity.project_name")',
          prop='projectId')
          ods-select(
            v-model='formDialogAddUserEntity.projectId',
            filterable,
            @change='changeProject()')
            ods-option(
              v-for='option in optionsUserEntityProject',
              :key='option.id',
              :label='option.name',
              :value='option.id')

        ods-form-item(
          :label='$t("user_detail.dialog_add_user_entity.party_tax_identification_number")',
          prop='partyId')
          ods-select(
            v-model='formDialogAddUserEntity.partyId',
            filterable,
            :filter-method='filterParties',
            :disabled='!showPartyAddEntity && optionsUserEntityProject.length > 1'
            @change='changeParty()')
            ods-option(
              v-for='option in optionsUserEntityParty',
              :key='option.id',
              :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
              :value='option.id')

        ods-form-item(
          :label='$t("user_detail.dialog_add_user_entity.centre_code")',
          prop='centreId')
          ods-select(
            v-model='formDialogAddUserEntity.centreId',
            :disabled='!showCentreAddEntity'
            filterable)
            ods-option(
              v-for='option in optionsUserEntityCentre',
              :key='option.id',
              :label='option.name',
              :value='option.id')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddUserEntity("formDialogAddUserEntity")')
          | {{ $t('user_detail.dialog_add_user_entity.button_add') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-usuario-detail',
  mixins: [Utils],

  data () {
    const validateContact = (rule, value, callback) => {
      if (this.formDialogAddUserMedia.mediaTypeName === 'email') {
        if (this.checkCorrectEmail(value)) {
          callback()
        } else {
          callback(new Error(this.$t('profile.contact.rules_form.email_format')))
        }
      } else {
        if (this.checkCorrectPhoneNumber(value)) {
          callback()
        } else {
          callback(
            new Error(this.$t('profile.contact.rules_form.phone_format'))
          )
        }
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (this.checkCorrectEmail(value)) {
        callback()
      } else if (value == null || value === '') {
        callback()
      } else {
        callback(new Error(this.$t('msg_generics.emailKo')))
      }
    }
    return {
      allProjects: [], // Proyectos del usuario seleccionado
      userProjects: [], // Proyectos del usuario
      userId: null,
      isAdmin: false, // Flag que indica si el usuario que se está editando es superadmin
      isActiveUserAdmin: false, // Flag que indica si el usuario logeado es superadmin
      isLocalProject: false,
      userSession: [],
      userDetailEditForm: {
        name: '',
        firstSurname: '',
        secondSurname: '',
        idNumber: '',
        department: '',
        enable: false
      },
      showProject: false,
      optionsAuthorities: [],
      optionsDelete: [
        {
          value: 'true',
          label: 'Si'
        }, {
          value: 'false',
          label: 'No'
        }],
      isShowDialogAddRole: false,
      formDialogAddRole: {
        servicio: null,
        role: null,
        borrable: null,
        description: null,
        permisos: []
      },
      rulesDialogAddRole: {
        role: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        description: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        servicio: [
          {
            required: false
          }
        ],
        borrable: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },

      // DATOS DE CONTACTO
      userMedia: [],
      currentRowUserMedia: {},
      isShowDialogAddUserMedia: false,
      formDialogAddUserMedia: {
        mediaTypeName: '',
        value: ''
      },
      rulesFormDialogAddUserMedia: {
        mediaTypeName: [
          { required: true, message: 'Selecciona un tipo de contacto', trigger: 'change' }
        ],
        value: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: validateContact, trigger: 'change' }
        ]
      },
      optionsUserMediaType: [],
      tid: null,

      // CAMBIO DE CORREO DE USUARIO
      isShowDialogChangeUserEmail: false,
      formDialogChangeUserEmail: {
        oldEmail: '',
        newEmail: ''
      },
      rulesFormDialogChangeUserEmail: {
        newEmail: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: validateEmail, trigger: 'change' }
        ]
      },

      // ENTIDADES DE USUARIO
      userEntities: [],
      showSaveUser: false,
      userEntityId: null,
      currentRowUserEntity: {},
      isShowDialogAddUserEntity: false,
      formDialogAddUserEntity: {
        projectId: '',
        partyId: '',
        centreId: ''
      },
      optionsUserEntityProject: [],
      optionsUserEntityParty: [],
      optionsUserEntityCentre: [],
      showPartyAddEntity: false,
      showCentreAddEntity: false,

      // PERFILES Y PERMISOS
      projectSelectedRolesAuthorities: null,
      optionsUserEntitiesRolesAuthorities: [],
      userRolesAuthorities: [],
      currentRole: {},
      authoritiesByRol: [],
      isNewRole: false,

      userMediaFlag: true,
      userMediaMessage: false,
      userEntityFlag: true,
      userEntityMessage: false,
      userAuthoritiesFlag: true,
      userAuthoritiesMessage: false
    }
  },

  computed: {
    ...mapGetters([
      // Permisos
      'activeUser',
      'canAdminUserAdvanced',
      'canAdminIndra',
      'canAdminProfile',
      'primaryColor',
      'urlIn'
    ]),

    rulesAddEntity () {
      const checkParty = (rule, value, callback) => {
        const projectId = this.formDialogAddUserEntity.projectId
        const partyId = this.formDialogAddUserEntity.partyId
        if (projectId !== null && projectId !== -1 && partyId === null) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      const checkCentre = (rule, value, callback) => {
        const projectId = this.formDialogAddUserEntity.projectId
        const partyId = this.formDialogAddUserEntity.partyId
        const centreId = this.formDialogAddUserEntity.centreId
        if (projectId !== null && projectId !== -1 && (partyId === null || centreId === null)) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      return {
        projectId: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        partyId: [
          { validator: checkParty, trigger: 'blur, change' }
        ],
        centreId: [
          { validator: checkCentre, trigger: 'blur, change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'getUserDetail',
      'getUserMedia',
      'addUserMedia',
      'deleteUserMedia',
      'updateUserMediaEmail',
      'getUserEntities',
      'addUserEntity',
      'deleteUserEntity',
      'getUserRolesAuthorities',
      'setRolesAndAuthorities',
      'getAuthoritiesByRol',
      'resetUserPassword',
      'deleteUser',
      'getOptionsMediaType',
      'getOptionsService',
      'getPartiesByProject',
      'getCentresByParty',
      'getCentresByPartyFenixBackend',
      'setStatusUser',
      'addUsersRole',
      'getAllAuthorities',
      'getUserByUsername'
    ]),

    async handleSetStatus () {
      const data = { id: this.userId, enable: this.userDetailEditForm.enable }
      try {
        await this.setStatusUser(data)
      } catch (error) {
        console.log('setStatusUser CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    // Reseteo al cerrar dialogo user media
    handleCloseDialogUserMedia () {
      this.$refs.formDialogAddUserMedia.resetFields()
    },

    // Reseteo al cerrar dialogo cambiar email
    handleCloseDialogChangeUserEmail () {
      this.$refs.formDialogChangeUserEmail.resetFields()
      this.isShowDialogChangeUserEmail = false
    },

    // Reseteo al cerrar dialogo dialogAddRole
    handleCloseDialog () {
      this.$refs.formDialogAddRole.resetFields()
    },

    // Reseteo al cerrar dialogo user entity
    handleCloseDialogUserEntity () {
      if (!(this.activeUser.data.projects && this.activeUser.data.projects.length === 1)) {
        this.$refs.formDialogAddUserEntity.resetFields()
        this.showPartyAddEntity = false
      } else {
        this.showPartyAddEntity = true
        this.formDialogAddUserEntity.partyId = null
        this.formDialogAddUserEntity.centreId = null
        this.optionsUserEntityParty = []
        this.optionsUserEntityCentre = []
      }
      this.showCentreAddEntity = false
    },

    getDescriptionAuthority: function (name) {
      return this.$t('authorities.' + name)
    },

    async handleCreateNewRole () {
      this.isNewRole = true
      this.authoritiesByRol = []
    },

    async handleChargeAuthoritiesByRole (role) {
      this.currentRole = role
      const dataQuery = {
        id: role.id
      }
      try {
        const response = await this.getAuthoritiesByRol(dataQuery)
        this.authoritiesByRol = response.content
        this.isNewProfile = false
      } catch (error) {
        console.log('handleChargeAuthoritiesByRole CATCH:: ' + error)
        this.showNotificationError(error)
      }
    },

    // ELIMINAR USUARIO
    handleDeleteUser () {
      try {
        this.$confirm(this.$t('user_detail.confirm.message_delete_user'), {
          title: this.$t('user_detail.confirm.title_delete_user'),
          confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          await this.deleteUser(this.userId)
          router.push({ name: 'usuarios-page' })
          this.$notify({
            title: this.$t('user_detail.notify.delete_user_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }).catch((error) => { this.getNotificationErrorMessage(error) })
      } catch (error) {
        console.log('handleDeleteUser CATCH:: ' + error)
        this.getNotificationErrorMessage(error)
      }
    },

    // RESETEO
    async handleResetPassword () {
      try {
        this.$confirm(this.$t('user_detail.confirm.title_reset_password'), {
          confirmButtonText: this.$t('user_detail.confirm.confirm_button_reset_password'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          await this.resetUserPassword(this.userId)
          this.$notify({
            title: this.$t('user_detail.notify.reset_password_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }).catch(() => {})
      } catch (error) {
        console.log('handleResetPassword CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    async handleDuplicateUser () {
      await this.loadUserEntity()
      await this.loadUserAuthorities()

      const duplicateData = {
        userentities: this.userEntities,
        rolesAuthoritiesUser: this.userRolesAuthorities,
        userId: this.userId,
        username: null,
        email: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        taxIdentificationNumber: null
      }
      this.$emit('duplicateData', duplicateData)
    },

    handleCellMouseEnterUserMedia (row, column, cell, event) {
      this.currentRowUserMedia = row
    },

    handleCellMouseEnterUserEntity (row, column, cell, event) {
      this.currentRowUserEntity = row
    },

    async loadUserMedia () {
      // Get user media
      if (this.userMediaFlag) {
        this.userMediaFlag = false
        await this.getUserMediaOnDatabase()
        this.userMediaMessage = true
      }
    },
    async loadUserEntity () {
      // Get entities
      if (this.canAdminUserAdvanced && this.userEntityFlag) {
        this.userEntityFlag = false
        await this.getUserEntitiesOnDatabase()
        this.userEntityMessage = true
      }
    },
    async loadUserAuthorities () {
      await this.loadUserEntity()
      // Get authorities
      if (this.canAdminUserAdvanced && this.userAuthoritiesFlag) {
        this.userAuthoritiesFlag = false
        await this.getUserRolesAuthoritiesOnDatabase()
        this.userAuthoritiesMessage = true
      }
    },

    // DATOS DE CONTACTO
    async removeUserMedia () {
      let load
      try {
        this.$confirm(this.$t('user_detail.confirm.title_delete_user_media'), {
          confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user_media'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          if (this.currentRowUserMedia.mediaTypeName === this.$t('mediaType.email')) {
            this.$confirm(this.$t('user_detail.confirm.change_user_email'), {
              center: true,
              iconClass: 'ods-icon-warning'
            }).then(async () => {
              this.isShowDialogChangeUserEmail = true
              this.formDialogChangeUserEmail.oldEmail = this.currentRowUserMedia.value
            })
          } else {
            load = this.$loading({
              lock: true,
              text: this.$t('user_detail.load.delete_user_media')
            })
            const dataQuery = {
              userId: this.userId,
              userMediaId: this.currentRowUserMedia.id
            }
            await this.deleteUserMedia(dataQuery)
            await this.getUserMediaOnDatabase()

            load.close()
            this.$notify({
              title: this.$t('user_detail.notify.delete_user_media'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }
        }).catch(() => {})
      } catch (error) {
        console.log('removeUserMedia CATCH: ', error)
        load.close()
      }
    },

    onSubmitAddUserMedia (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('user_detail.load.add_user_media')
          })
          try {
            const dataQuery = {
              userId: this.userId,
              query: {
                type: this.formDialogAddUserMedia.mediaTypeName,
                value: this.formDialogAddUserMedia.value
              }
            }
            await this.addUserMedia(dataQuery)
            await this.getUserMediaOnDatabase()
            this.isShowDialogAddUserMedia = false

            this.$notify({
              title: this.$t('user_detail.notify.add_user_media'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('onSubmitAddUserMedia CATCH: ', error)
            this.showNotificationError(error)
          } finally {
            load.close()
          }
        } else {
          console.log('ERROR submit!!')
          return false
        }
      })
    },

    async onSubmitChangeUserEmail (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('user_detail.load.change_user_email')
          })
          try {
            // Actualizar el email
            const dataQuery = {
              userId: this.userId,
              userMediaId: this.currentRowUserMedia.id,
              query: {
                email: this.formDialogChangeUserEmail.newEmail
              }
            }
            await this.updateUserMediaEmail(dataQuery)

            // Actualizar datos de contacto
            await this.getUserMediaOnDatabase()
            this.isShowDialogChangeUserEmail = false

            load.close()
            this.$notify({
              title: this.$t('user_detail.notify.change_user_email'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('onSubmitChangeUserEmail CATCH: ', error)
            this.showNotificationError(error)
          } finally {
            load.close()
          }
        } else {
          console.log('ERROR onSubmitChangeUserEmail: invalid form!!')
          return false
        }
      })
    },

    // ENTIDADES DE USUARIO
    async changeProject () {
      // Reseteamos tanto la empresa como el centro
      this.formDialogAddUserEntity.partyId = null
      this.optionsUserEntityParty = []
      this.formDialogAddUserEntity.centreId = null
      this.optionsUserEntityCentre = []
      this.showPartyAddEntity = true
      // Para pintar los datos de la tabla
      for (const option of this.optionsUserEntityProject) {
        if (option.id === this.formDialogAddUserEntity.projectId) {
          this.projectSelected = option.name
        }
      }

      const partyAll = {
        id: -1,
        tradeName: this.$t('user_detail.dialog_add_user_entity.option_all_party')
      }
      // Agregamos al inicio del array
      this.optionsUserEntityParty.unshift(partyAll)
    },

    async changeParty () {
      // Reseteamos el centro
      this.formDialogAddUserEntity.centreId = null
      this.optionsUserEntityCentre = []
      if (this.formDialogAddUserEntity.partyId !== -1) {
        try {
          const data = {
            projectId: this.formDialogAddUserEntity.projectId,
            partyId: this.formDialogAddUserEntity.partyId
          }
          this.optionsUserEntityCentre = await this.getCentresByPartyFenixBackend(data)
          for (const option of this.optionsUserEntityCentre) {
            if (option.name !== this.$t('user_detail.dialog_add_user_entity.option_all_centre')) {
              option.name = option.code
            }
          }
        } catch (error) {
          console.log('changeParty CATCH: ', error)
          this.showNotificationError(error)
        }
      }
      const centreAll = {
        id: -1,
        name: this.$t('user_detail.dialog_add_user_entity.option_all_centre')
      }
      // Agregamos al inicio del array
      this.optionsUserEntityCentre.unshift(centreAll)
      // Habilitamos campo
      this.showCentreAddEntity = true
    },
    async getPartiesResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const datos = {
        projectId: this.formDialogAddUserEntity.projectId,
        query: {
          size: 1000,
          enabled: true,
          tradeNameOrTaxId: data,
          urlName: (this.urlIn && this.urlIn !== 'b2b' ? this.urlIn : null)
        }
      }
      try {
        if (this.formDialogAddUserEntity.projectId !== -1) {
          this.optionsUserEntityParty = await this.getPartiesByProject(datos)
        }
        const partyAll = {
          id: -1,
          tradeName: this.$t('user_detail.dialog_add_user_entity.option_all_party')
        }
        // Agregamos al inicio del array
        this.optionsUserEntityParty.unshift(partyAll)
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },
    async filterParties (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.optionsUserEntityParty = []
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    //* * Valida los user-entity */
    validateUserEntities (entityToAdd) {
      // Verificamos que la lista no esta vacia
      if (this.userEntities !== null && this.userEntities.length > 0) {
        const ALLPROJECTS = null
        const ALLPARTIES = null
        const ALLCENTRES = null
        for (const entity of this.userEntities) {
          if (entity.projectId === ALLPROJECTS || entityToAdd.query.projectId === ALLPROJECTS) {
            return true
          } else if (entity.projectId === entityToAdd.query.projectId) {
            if (entity.partyId === ALLPARTIES || entityToAdd.query.partyId === ALLPARTIES) {
              return true
            } else if (entity.partyId === entityToAdd.query.partyId) {
              if (entity.centreId === ALLCENTRES || entityToAdd.query.centreId === ALLCENTRES) {
                return true
              } else if (entity.centreId === entityToAdd.query.centreId) {
                return true
              }
            }
          }
        }
      }
      return false
    },

    //* * Valida si el userentity ya a sido insertado previamete */
    validateUserEntitiesRepeat (entityToAdd) {
      // Verificamos que la lista no esta vacia
      if (this.userEntities !== null && this.userEntities.length > 0) {
        // Verificamos que no se añadido previamnete
        for (const entity of this.userEntities) {
          if (entity.projectId === entityToAdd.query.projectId && entity.partyId === entityToAdd.query.partyId && entity.centreId === entityToAdd.query.centreId) {
            return true
          }
        }
      }
      return false
    },

    async onSubmitAddUserEntity (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('user_detail.load.add_user_entity')
          })
          try {
            const dataQuery = {
              userId: this.userId,
              query: {
                projectId: this.formDialogAddUserEntity.projectId === -1 ? null : this.formDialogAddUserEntity.projectId,
                partyId: this.formDialogAddUserEntity.partyId === -1 ? null : this.formDialogAddUserEntity.partyId,
                centreId: this.formDialogAddUserEntity.centreId === -1 ? null : this.formDialogAddUserEntity.centreId,
                userEntityId: this.userEntityId
              }
            }

            // Validamos que no volvemos a insertar un user_entity ya agregado previamente
            // console.log('PROJECT', dataQuery.query.projectId + 'PARTY', dataQuery.query.partyId + 'CENTRE', dataQuery.query.centreId)
            let validate = true
            if (this.validateUserEntitiesRepeat(dataQuery)) {
              this.$notify({
                title: this.$t('user_detail.notify.add_user_entity_repeat'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
              // Si salta validacion ya no hacemos mas comprobaciones
              validate = false
            }

            if (!this.validateUserEntities(dataQuery) && validate) {
              await this.addUserEntity(dataQuery)
              if (this.userEntities.length === 0 && this.userEntityId) {
                await this.deleteHidenEntity()
              }
              await this.getUserEntitiesOnDatabase()
              await this.getUserRolesAuthoritiesOnDatabase()
              this.showSaveUser = false
              this.userEntityId = null
              this.$notify({
                title: this.$t('user_detail.notify.add_user_entity'),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            } else {
              this.$notify({
                title: this.$t('user_detail.notify.add_user_entity_validateko'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            }
            if (!(this.activeUser.data.projects && this.activeUser.data.projects.length === 1)) {
              this.$refs[formName].resetFields()
            }
            this.isShowDialogAddUserEntity = false
          } catch (error) {
            console.log('onSubmitAddUserEntity CATCH: ', error)
            this.showNotificationError(error)
          } finally {
            load.close()
          }
        } else {
          console.log('ERROR submit!!')
          return false
        }
      })
    },
    async deleteHidenEntity () {
      const dataQuery = {
        userId: this.userId,
        entityId: this.currentRowUserEntity.id
      }
      await this.deleteUserEntity(dataQuery)
    },
    async saveUser () {
      if (this.userEntities.length === 0) {
        this.$notify({
          title: this.$t('user_detail.notify.save_user_entityko'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      } else if (this.userEntityId) {
        const load = this.$loading({
          lock: true,
          text: this.$t('user_detail.load.delete_user_entity')
        })
        try {
          await this.deleteHidenEntity()
          await this.getUserEntitiesOnDatabase()
          await this.getUserRolesAuthoritiesOnDatabase()

          this.$notify({
            title: this.$t('user_detail.notify.delete_user_entity'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('onSubmitAddUserEntity CATCH: ', error)
          this.showNotificationError(error, 10000, 'error')
        } finally {
          load.close()
        }
      }
    },

    async removeUserEntity () {
      this.userEntityId = null
      if (this.userEntities.length === 1) {
        this.$confirm(this.$t('user_detail.confirm.title_delete_user_entity'), {
          confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user_entity'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          const load = this.$loading({
            lock: true,
            text: this.$t('user_detail.load.delete_user_entity')
          })
          this.userEntityId = this.currentRowUserEntity.id

          console.log('this.currentRowUserEntity: ', this.currentRowUserEntity)
          console.log('idParty: ', this.userEntityId)
          this.userEntities = []
          this.showSaveUser = true
          load.close()
          this.$notify({
            title: this.$t('user_detail.notify.delete_user_entity'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }).catch(() => {})
      }
      // Solo se eliminaran si hay mas de un elemento
      if (this.userEntities.length > 1) {
        let load
        try {
          this.$confirm(this.$t('user_detail.confirm.title_delete_user_entity'), {
            confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user_entity'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            load = this.$loading({
              lock: true,
              text: this.$t('user_detail.load.delete_user_entity')
            })
            const dataQuery = {
              userId: this.userId,
              entityId: this.currentRowUserEntity.id
            }
            await this.deleteUserEntity(dataQuery)
            await this.getUserEntitiesOnDatabase()
            await this.getUserRolesAuthoritiesOnDatabase()
            this.$notify({
              title: this.$t('user_detail.notify.delete_user_entity'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch((error) => {
            console.log('removeUserEntity CATCH: ', error)
            this.showNotificationError(error)
          }).finally(() => {
            load.close()
          })
        } catch (error) {
          console.log('removeUserEntity CATCH: ', error)
        }
      }
    },

    // PERFILES Y PERMISOS
    async changeProjectSelected () {
      await this.getUserRolesAuthoritiesOnDatabase()
    },

    async changeRoleAuthorities () {
      const load = this.$loading({
        lock: true,
        text: this.$t('user_detail.load.change_roles_user')
      })
      try {
        // Tenemos que obtener el array id de roles y de authorities que esten seleccionados
        const roles = []
        for (const rol of this.userRolesAuthorities.roles) {
          if (rol.enabled) {
            roles.push(rol.id)
          }
        }
        const dataQuery = {
          userId: this.userId,
          query: {
            roles: roles,
            projectId: this.projectSelectedRolesAuthorities
          }
        }
        const response = await this.setRolesAndAuthorities(dataQuery)
        this.userRolesAuthorities = response
        this.$notify({
          title: this.$t('profile.notify.changes_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('changeRoleAuthorities CATCH: ' + error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    async cancelChangeRoleAuthorities () {
      // Quitamos el foco del boton
      this.$refs.buttonCancel.$el.blur()
      await this.getUserRolesAuthoritiesOnDatabase()
    },

    // METODOS GENERALES PARA LLAMAR A SERVICIOS
    async getUserOnDatabase () {
      try {
        const user = await this.getUserDetail(this.userId)
        this.userDetailEditForm = user
      } catch (error) {
        console.log('getUserOnDatabase CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    // Metodo para recuperar todos los permisos existentes
    // Se compara con los que tiene el usuario en session
    async allAuthorities () {
      try {
        const data = {
          userId: this.userSession.id
        }
        const response = await this.getAllAuthorities(data)
        const rAllAuthorities = response
        const userSessionAuthorities = this.activeUser.data.authorities
        for (const userAuthority of userSessionAuthorities) {
          for (const allAuthority of rAllAuthorities) {
            if (userAuthority === allAuthority.name) {
              this.optionsAuthorities.push(allAuthority)
            }
          }
        }
      } catch (error) {
        console.log('allAuthorities CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    // Metodo para crear perfiles
    async onSubmitAddRole (formRole) {
      this.$refs[formRole].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('profiles.load.add_profile')
          })
          try {
            let servicioId = this.formDialogAddRole.servicio
            if (servicioId === null || servicioId === undefined) {
              servicioId = 'allProjects'
            }
            const data = {
              userId: this.userId,
              query: {
                project: servicioId,
                role: this.formDialogAddRole.role,
                description: this.formDialogAddRole.description,
                borrable: this.formDialogAddRole.borrable,
                permisos: this.formDialogAddRole.permisos
              }
            }
            await this.addUsersRole(data)
            this.isShowDialogAddRole = false
            this.$notify({
              title: this.$t('user_detail.notify.add_role'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getUserRolesAuthoritiesOnDatabase()
          } catch (error) {
            console.log('onSubmitAddRole CATCH: ', error)
            this.showNotificationError(error)
          } finally {
            load.close()
          }
        } else {
          console.log('ERROR submit!!')
          return false
        }
      })
    },

    async getUserMediaOnDatabase () {
      try {
        const response = await this.getUserMedia(this.userId)
        this.userMedia = response
        for (const media of this.userMedia) {
          media.mediaTypeName = this.$t('mediaType.' + media.mediaTypeName)
        }
      } catch (error) {
        console.log('getUserMediaOnDatabase CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    async getUserEntitiesOnDatabase () {
      try {
        // Reiniciamos el select de proyectos de perfiles y permisos
        // Solo si el usuario loggeado es superadmin se puede ver la opción: Todos
        if (this.isActiveUserAdmin) {
          this.optionsUserEntitiesRolesAuthorities = [{
            projectId: null,
            projectName: this.$t('user_detail.dialog_add_user_entity.option_all_project')
          }]
        } else {
          this.optionsUserEntitiesRolesAuthorities = []
        }
        // Obtenemos las entidades de usuario
        const dataQuery = {
          userId: this.userId
        }
        const response = await this.getUserEntities(dataQuery)
        this.userEntities = response

        // Si es superadmin se deben sacar todos los proyectos
        if (this.userEntities !== null && this.userEntities.length === 1 && this.userEntities[0].projectId === null) {
          // Añadimos los proyectos
          for (const obj of this.allProjects) {
            const aux = {
              projectId: obj.id,
              projectName: obj.name
            }
            this.optionsUserEntitiesRolesAuthorities.push(aux)
          }
        }
        for (const entity of this.userEntities) {
          // Cambiamos las etiquetas para que aparezcan como deseamos en la tabla
          if (entity.projectId === null) {
            entity.projectName = this.$t('user_detail.dialog_add_user_entity.option_all_project')
          } else {
            if (this.userProjects.indexOf(entity.projectId) < 0) {
              this.userProjects.push(entity.projectId)
            }
          }
          if (entity.centreId === null) {
            entity.centreCode = this.$t('user_detail.dialog_add_user_entity.option_all_centre')
          } else {
            entity.centreCode = entity.centreCode + (entity.centreDescription === null ? '' : '-' + entity.centreDescription)
          }
          if (entity.partyId === null) {
            entity.partyTaxIdentificationNumber = this.$t('user_detail.dialog_add_user_entity.option_all_party')
          } else {
            entity.partyTaxIdentificationNumber = entity.partyTradeName + '-' + entity.partyTaxIdentificationNumber
          }
          // Añadimos las entidades NO REPETIDAS en el array de opciones del select de proyectos y perfiles
          if (!this.optionsUserEntitiesRolesAuthorities.some(this.filterItems(entity))) {
            this.optionsUserEntitiesRolesAuthorities = this.optionsUserEntitiesRolesAuthorities.concat(entity)
          }
        }
        // ordenamos el resultado
        this.optionsUserEntitiesRolesAuthorities.sort((a, b) => (a.projectName.toUpperCase().localeCompare(b.projectName.toUpperCase())))

        // Si el array de opciones de proyecto solo tiene 1 proyecto asociado (filtrando la opción de todos), lo seleccionamos
        const projectsRole = this.optionsUserEntitiesRolesAuthorities.filter(ue => ue.projectId !== null)
        if (projectsRole.length === 1) {
          this.projectSelectedRolesAuthorities = projectsRole.length > 0 ? projectsRole[0].projectId : null
        } else if (!this.isActiveUserAdmin && this.optionsUserEntitiesRolesAuthorities.length > 0) {
          this.projectSelectedRolesAuthorities = this.optionsUserEntitiesRolesAuthorities[0].projectId
        }
        this.formDialogAddRole.servicio = this.projectSelectedRolesAuthorities
      } catch (error) {
        console.log('getUserMediaOnDatabase CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    filterItems (entity) {
      return item => item.projectId === entity.projectId
    },

    async getUserRolesAuthoritiesOnDatabase () {
      if (this.projectSelectedRolesAuthorities === undefined) {
        this.projectSelectedRolesAuthorities = null
      }
      const dataQuery = {
        userId: this.userId,
        query: {
          projectId: this.projectSelectedRolesAuthorities// ,
          // projectList: this.userProjects
        }

      }
      try {
        const response = await this.getUserRolesAuthorities(dataQuery)
        this.userRolesAuthorities = response
      } catch (error) {
        console.log('getUserRolesAuthoritiesOnDatabase CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          if (error.data.message) {
            errorSms = error.data.message
          } else {
            errorSms = 'global_error'
          }
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = this.$t('error.e404')
          break
        case 500:
          errorSms = this.$t('error.user')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }

  },

  async created () {
    this.userId = this.$route.params.userId

    const load = this.$loading({
      lock: true,
      text: this.$t('user_detail.load.init_user_data')
    })
    try {
      const dataQueryService = {
        page: 0,
        size: 1000,
        sort: 'name,ASC'
      }
      const userSessionPromise = this.getUserByUsername(this.activeUser.data.username)
      const optionsUserMediaTypePromise = this.getOptionsMediaType()
      this.isLocalProject = (this.urlIn && this.urlIn !== 'b2b')
      console.log('Web personalizada: ', this.isLocalProject)

      this.isActiveUserAdmin = this.activeUser.data.isSuperAdmin
      this.userSession = await userSessionPromise
      this.allAuthorities()
      this.optionsUserMediaType = await optionsUserMediaTypePromise
      this.allProjects = await this.getOptionsService(dataQueryService)

      // Web personalizada
      if (this.isLocalProject) {
        this.showProject = false
      } else if (this.allProjects.length > 1) { // Si hay más de una opción de proyectos, se muestra el combo
        this.showProject = true
      }
      // Si solo tiene un proyecto, inicializarlo
      if (this.allProjects.length === 1) {
        this.optionsUserEntityProject = this.allProjects
        this.formDialogAddUserEntity.projectId = this.allProjects[0].id
        this.formDialogAddRole.servicio = this.allProjects[0].id
        this.projectSelectedRolesAuthorities = this.allProjects[0].id
        this.changeProject()
      } else {
        // Solo se puede crear usuarios superadmin si el usuario loggeado es superadmin
        if (this.isActiveUserAdmin) {
          this.optionsUserEntityProject = [{
            id: -1,
            name: this.$t('user_detail.dialog_add_user_entity.option_all_project')
          }]
        }
        // Añadir el resto de proyectos
        this.optionsUserEntityProject = this.optionsUserEntityProject.concat(
          this.allProjects
        )
      }

      // Get Info
      await this.getUserOnDatabase()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.showNotificationError(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-usuario-detail {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }

  .box-role{
    margin: 0rem;
  }

  ::v-deep .profiles{
    .wrap-styles {
      height: rem(400);
      border-radius: rem(8);
    }

    .ods-module{
      &__body{
        padding: 20px;
      }
    }
    .active{
      background-color: var(--color-bg-interactive);

      .ods-checkbox{
        .ods-checkbox__label {
          color: var(--color-bg-primary);
        }
        color: var(--color-bg-primary);
      }
      .ods-button{
        color: var(--color-bg-primary);
      }
    }
  }

  .div-authority{
    height: 400px;
    overflow-y: auto;
  }

  .box-authority{
    margin: 0rem;
  }

  &__form-actions {
    margin: 3rem;
    .ods-button {
      float: right;
      margin-left: 1rem;
    }
  }

}
::v-deep .ods-tag{
    background-color: transparent !important;
}
</style>
